



























































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalEdit/types";
import EditMonthChangePicker from "@/components/common/EditMonthChangePicker.vue";
@Component({
  components: { EditMonthChangePicker }
})
export default class BasicInfo9 extends Vue {
  @Prop() tab!: MedicalSpecification;
}
